import * as React from "react";
import { SVGProps } from "react";

const Syscoin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 228 218" {...props}>
    <defs>
      <style>{".cls-1{fill:#008dd0;fill-rule:evenodd}"}</style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Layer_1-3" data-name="Layer_1">
          <g id="_2621096421008" data-name={2621096421008}>
            <path
              d="M207.33 82.72C196 72 180 63.07 159.24 57.4h-.12c-49.4-13.44-67 18.35-27 38.39 45.41 22.72 51.72 59.93 26.09 83.2-6.53 5.92-27.75 17-47.27 19.66-31 4.3-65.4-2.29-93.36-11.17a147.09 147.09 0 0 0 51.15 25.64c43.59 12 96.24 3.16 131.13-27.17 35.14-30.59 38.5-73.95 7.47-103.23Zm-48.07-25.31.45.13Z"
              className="cls-1"
            />
            <path
              d="M64.28 11A148.53 148.53 0 0 1 211 30.89c-52.2-16.6-92.7-15.16-119.27-4.47l-.39.16C58.53 40 47.16 67.47 61.44 92.31c7.69 13.39 21.25 23.4 35 30.27 36.36 18.21 25.18 46.1-14.19 41a95.2 95.2 0 0 1-12.94-2.65C-8 139.82-19.31 74.17 28.71 32.42A126.92 126.92 0 0 1 64.28 11Z"
              className="cls-1"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Syscoin;
